<template>
  <div>
    <br>
    <el-form ref="form" :model="viewForm" label-width="90px">
      <el-form-item label="First Name:">
        <b>{{viewForm.FirstName}}</b>
      </el-form-item>
      <el-form-item label="Last Name:">
        <b>{{viewForm.LastName}}</b>
      </el-form-item>
      <el-form-item label="Emails:">
        <div v-for="(email, i) in viewForm.EmailAddresses" :key="`e-${i}`">
          <a :href="'mailto:'+email.Email">{{email.Email}}</a>
        </div>
      </el-form-item>
      <el-form-item label="Phone #'s:">
        <div v-for="(phone, i) in viewForm.PhoneNumbers" :key="`p-${i}`">
          <div v-if="phone.Number">
            <a class="a-pad" :href="'tel:'+phone.Number">call</a>
            <a class="a-pad" :href="'sms:'+phone.Number">text</a>
            <span>{{phone.Number}}</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="Addresses:">
        <div v-for="(address, i) in viewForm.Addresses" :key="`a-${i}`">
          <a
            :href="'http://maps.google.com/?q=' + address.Address"
            target="_blank"
          >{{address.Address}}</a>
        </div>
      </el-form-item>
      <el-form-item label="Notes:">
        <notes
          @deleteNote="onDeleteNote"
          @addNote="onAddNote"
          @editNote="onEditNote"
          :notes="viewForm.Notes"
        />
      </el-form-item>
      <el-button
        v-if="!viewForm.MentorId"
        round
        size="small"
        @click="$emit('edit')"
        icon="el-icon-edit-outline"
      >Edit Contact</el-button>
      <el-button
        round
        size="small"
        @click="onDeleteContact"
        v-if="!viewForm.MentorId"
        type="danger"
        icon="el-icon-delete"
      >Delete Contact</el-button>
    </el-form>
  </div>
</template>
<script>
import Notes from '@/components/contacts/Notes'

export default {
  props: ['viewForm'],
  methods: {
    onAddNote(newNote) {
      this.$emit('addNote', newNote)
    },
    onDeleteNote(note) {
      this.$emit('deleteNote', note)
    },
    onDeleteContact() {
      this.$confirm(
        'This will permanently delete this contact. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.$emit('delete', this.viewForm.Id)
        })
        .catch(() => {})
    },
    onEditNote(note) {
      this.$emit('editNote', note)
    }
  },
  components: {
    Notes
  }
}
</script>

<style lang="css" scoped>
.a-pad {
  padding-right: 10px;
}
</style>
